/*
  Lightweight scroll parallax for decorative elements.
  Elements opt in with data-nuva-parallax="<factor>"; each is shifted by
  -factor × its distance from the viewport centre via translate3d.
  Runs as a persistent rAF loop keyed to scroll position (most reliable
  across Safari's momentum scrolling). Disabled for prefers-reduced-motion.
*/
(function () {
  if (window.__nuvaParallax) return;
  window.__nuvaParallax = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = [];
  var lastY = null;
  var wrapper = null;

  function collect() {
    els = Array.prototype.slice.call(document.querySelectorAll('[data-nuva-parallax]'));
    // Horizon scrolls an inner .page-wrapper on desktop (html/body are
    // overflow:hidden >=990px); on mobile the window scrolls. Sum both.
    wrapper = document.querySelector('.page-wrapper');
    lastY = null; // force a repaint pass
  }

  function tick() {
    var y = (window.pageYOffset || document.documentElement.scrollTop || 0)
      + (wrapper ? wrapper.scrollTop : 0);
    if (y !== lastY) {
      lastY = y;
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -300 || r.top > vh + 300) continue;
        var factor = parseFloat(el.getAttribute('data-nuva-parallax')) || 0.1;
        var offset = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-offset * factor).toFixed(1) + 'px,0)';
      }
    }
    window.requestAnimationFrame(tick);
  }

  function start() {
    collect();
    window.requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('resize', collect, { passive: true });

  // Theme editor adds/removes sections without a page load.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', collect);
  }
})();

/*
  Eased anchor scrolling: same-page anchor clicks glide with an
  ease-in-out curve instead of the browser's fixed-speed smooth scroll.
  Uses the same wrapper-aware scroller logic as the parallax above.
*/
(function () {
  if (window.__nuvaSmoothScroll) return;
  window.__nuvaSmoothScroll = true;

  var HEADER_OFFSET = 80;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getScroller() {
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1) return wrapper;
    return null; // window scrolls
  }

  function animateTo(target) {
    var scroller = getScroller();
    var delta;
    // Landing on a pinned scroll-story at progress 0 shows an empty stage;
    // carry the glide far enough into the runway that card one has fully
    // fully assembled (97% of the pin's scrub distance).
    var pin = target.querySelector && target.querySelector('[data-nuva-story].nuva-story-active');
    if (pin) {
      var pr = pin.getBoundingClientRect();
      delta = pr.top + Math.max(0, pr.height - window.innerHeight) * 0.97;
    } else {
      delta = target.getBoundingClientRect().top - HEADER_OFFSET;
    }
    if (Math.abs(delta) < 2) return;

    var startY = scroller ? scroller.scrollTop : (window.pageYOffset || 0);
    var duration = Math.min(1600, Math.max(800, Math.abs(delta) * 0.55));
    var startT = null;
    var prevBehavior;

    var behaviorEl = scroller || document.documentElement;
    prevBehavior = behaviorEl.style.scrollBehavior;
    behaviorEl.style.scrollBehavior = 'auto'; // keep CSS smooth from fighting us

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function frame(now) {
      if (startT === null) startT = now;
      var p = Math.min(1, (now - startT) / duration);
      var y = startY + delta * easeInOutCubic(p);
      if (scroller) {
        scroller.scrollTop = y;
      } else {
        window.scrollTo(0, y);
      }
      if (p < 1) {
        window.requestAnimationFrame(frame);
      } else {
        behaviorEl.style.scrollBehavior = prevBehavior;
      }
    }
    window.requestAnimationFrame(frame);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (reduceMotion) {
      target.scrollIntoView();
      return;
    }
    animateTo(target);
  });
})();
